module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1045-b7934d950038f6cc43cc3ac1e540873d.png";